import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { ROUTE_PATHS } from 'src/app/route-paths';
import { environment } from 'src/environments/environment';
import { WitnessAuthenticationComponent } from '../witness-authentication/witness-authentication.component';
import { UpdatePinComponent } from '../update-pin/update-pin.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  standalone: false
})
export class SidebarComponent {
  private router = inject(Router);
  private messageService = inject(MessageService);
  authService = inject(AuthService);

  readonly routePaths = ROUTE_PATHS;
  @Input() deId?: boolean;
  @Input() dissableDeIdSwitch = false;
  @Output() deIdChange = new EventEmitter<boolean>();

  @ViewChild('witnessAuthDialog') witnessAuthDialog!: WitnessAuthenticationComponent;
  @ViewChild('updatePinDialog') updatePinDialog!: UpdatePinComponent;

  enableAssayManagement = environment.enableAssayManagement;
  disableWitnessAuth = environment.disableWitnessAuth;

  get effectiveDeId(): boolean {
    return this.deId ?? this.authService.getDeIdentifiedMode();
  }

  getP2pLink(): string {
    return `/peer-to-peer/${this.effectiveDeId}`;
  }

  authenticateWitness(): void {
    if (this.disableWitnessAuth) {
      this.authService.loginAuthorizedWitness().subscribe({
        next: (result) => {
          this.authService.setWitnesToken(result);
          this.router.navigate(['/' + ROUTE_PATHS.assayManagement + '/' + this.effectiveDeId.toString()]);
        },
        error: () => {
          if (this.witnessAuthDialog) {
            this.witnessAuthDialog.showDialog = false;
          }
          this.messageService.add({
            key: 'session',
            severity: 'error',
            summary: 'Unable to access Assay Management',
            detail: 'Please try again or contact support.',
            life: 4000
          });
        }
      });
    } else {
      if (this.witnessAuthDialog) {
        this.witnessAuthDialog.showDialog = true;
      }
    }
  }

  showPincodeUpdateModal(): void {
    if (this.witnessAuthDialog) {
      this.witnessAuthDialog.showDialog = false;
    }
    if (this.updatePinDialog) {
      this.updatePinDialog.showDialog = true;
    }
  }

  deIdUpdate(): void {
    this.deIdChange.emit(this.effectiveDeId);
  }
}
